var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:url(#SVGID_1_);} .st1{fill:url(#SVGID_2_);} .st2{fill:#FFFFFF;} ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1703.8413,
    y1: -1210.2029,
    x2: -1703.2668,
    y2: -1206.9454,
    gradientTransform: "matrix(-9.7656 0 0 9.7656 -16621.3789 11817.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAE42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF3E31"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,0h16.4c0.8,0,1.6,0.1,2.3,0.4c1.1,0.4,2.1,1.1,2.8,2c0.8,0.9,1.3,2,1.4,3.2c0.1,0.4,0.1,0.9,0.1,1.3v16 c0,0.5,0,1-0.1,1.5c-0.2,1.1-0.8,2.2-1.6,3.1c-0.8,0.9-1.8,1.5-2.9,1.9c-0.7,0.2-1.4,0.3-2.1,0.3c-0.3,0-16.5,0-16.7,0 C5.1,29.6,4,29.2,3,28.6C2,27.9,1.2,27,0.7,26c-0.4-0.9-0.7-1.9-0.7-2.9V6.6c0-1,0.2-2,0.6-2.8c0.5-1,1.3-2,2.2-2.6 c1-0.7,2.1-1.1,3.3-1.1C6.4,0,6.5,0,6.6,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.627,
    y1: 35.5411,
    x2: -6.0476,
    y2: 33.1556,
    gradientTransform: "matrix(9.7656 0 0 -9.7656 70.125 347.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39F3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D33929"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,24.3c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3-0.3-0.6-0.6-1-0.9c-0.5-0.3-1-0.5-1.6-0.5c-0.4,0-0.8,0-1.2,0.2 c-0.4,0.1-0.7,0.3-1.1,0.5c-0.4,0.2-0.8,0.4-1.2,0.6c-0.5,0.2-1,0.4-1.6,0.5c-0.7,0.1-1.4,0.2-2.1,0.2c-1.2,0-2.5-0.2-3.7-0.6 c-1-0.3-2-0.7-3-1.3c-0.8-0.5-1.6-1-2.3-1.6c-0.6-0.5-1.1-1.1-1.6-1.6c-0.3-0.4-0.7-0.8-1-1.3c-0.1-0.2-0.2-0.4-0.3-0.5L0,14.1V6.6 C0,2.9,3,0,6.6,0h5.9l4.3,4.4c9.8,6.7,6.6,14,6.6,14S26.2,21.5,25.1,24.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.8,4.4c9.8,6.7,6.6,14,6.6,14s2.8,3.1,1.7,5.9c0,0-1.1-1.9-3.1-1.9c-1.9,0-2.9,1.9-6.7,1.9 c-8.3,0-12.2-6.9-12.2-6.9c7.5,4.9,12.6,1.4,12.6,1.4C12.3,16.8,5.1,7.5,5.1,7.5c6.3,5.3,9,6.7,9,6.7C12.5,12.9,8,6.3,8,6.3 c3.6,3.7,10.8,8.8,10.8,8.8C20.8,9.5,16.8,4.4,16.8,4.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.3599e8720831104287b7dc403337270c.svg";
export { ForwardRef as ReactComponent };